import { BaseService } from './BaseService';
import { createSingleton } from './singleton';
import { extractErrorMessage } from './extractErrorMessage';
import { ERROR, LOADING } from './constants';
import { getSettings, fixRequestUrl } from '@bi/sync';
import debug from 'debug';
const error = debug('core:AppConfig:error');
const warn = debug('core:AppConfig:warn');
//                                                                
function makeLocale(localeId) {
    switch (localeId) {
        case 'english':
            return 'en-US';
        case 'russian':
            return 'ru-RU';
        case 'en':
            return 'en-US';
        case 'ru':
            return 'ru-RU';
    }
    if (localeId.match(/^(\w\w)[_-](\w\w)$/))
        return RegExp.$1 + '-' + RegExp.$2;
    warn(`Unknown locale "${localeId}". Using en-US instead`);
    return 'en-US';
}
function makeAppConfig(biSettings) {
    let locale = 'en-US';
    if (typeof biSettings.language === 'string')
        locale = makeLocale(biSettings.language);
    if (typeof biSettings.locale === 'string')
        locale = makeLocale(biSettings.locale);
    locale.match(/^(\w\w)-(\w\w)$/);
    const language = RegExp.$1, region = RegExp.$2;
    const features = Array.isArray(biSettings.features) ? biSettings.features : [];
    let plugins = biSettings.plugins;
    if (!plugins) {
        plugins = [];
        if (biSettings.bookmarksEnabled) {
            plugins.push('presentations');
        }
    }
    return {
        ...biSettings,
        loading: false,
        error: null,
        requestUrls: biSettings.requestUrls,
        projectTitle: typeof biSettings.projectTitle === 'string' ? biSettings.projectTitle : 'Luxms BI',
        locale,
        language,
        region,
        features,
        plugins,
        entryPoint: biSettings.entryPoint || null,
        dataset: biSettings.dataset || {},
        map: biSettings.map || {},
        themes: biSettings.themes || null,
        keycloak: biSettings.keycloak || null,
    };
}
export class AppConfig extends BaseService {
    constructor() {
        //                                                                     
        //                                                                  
        //                                                        
        super({ [LOADING]: true, [ERROR]: null, loading: true, error: null });
        //                                                                      
        //                                                                      
        //                                                                            
        const result = getSettings();
        if (result instanceof Promise) {
            result.then((data) => this._setModel(makeAppConfig(data)), (err) => {
                error(err);
                this._updateModel({ ...makeAppConfig({}), error: extractErrorMessage(err) });
            });
        }
        else {
            this._setModel(makeAppConfig(result));
        }
    }
    hasFeature(featureName) {
        return this._model.features.indexOf(featureName) !== -1;
    }
    /* 
                                                   
                                                    
     */
    fixRequestUrl(url) {
        return fixRequestUrl(url);
    }
    static getInstance = createSingleton(() => new AppConfig(), '__appConfig');
    static getModel() {
        return this.getInstance().getModel();
    }
    static fixRequestUrl(url) {
        return fixRequestUrl(url);
    }
    static hasFeature(featureName) {
        return this.getInstance().hasFeature(featureName);
    }
    static getProjectTitle() {
        return this.getModel().projectTitle;
    }
    static getLocale() {
        return this.getModel().locale;
    }
    static getLanguage() {
        return this.getModel().language;
    }
    static getPlugins() {
        return this.getModel().plugins;
    }
}
